import { Modal, Spin } from 'antd';
import { Formik } from 'formik';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InputFromUser } from '../Input/input';
import { getAllMemberShip, getAllMemberShipVerifyList, ActionGetRoomTypeOptions } from '../../store/Actions/MasterDataAction';
import { ActionGetOccupancyModeOptions } from '../../store/Actions/occupancyAction';
import { ExpendableTable } from '../Table/expendableTable';
import { GetAllProgrammeList } from '../../store/Actions/ServiceAction';
import { AddMemberShipValidationSchema } from '../../utils/FormValidation';
import PropTypes from 'prop-types';
import { ActionUpdateById } from '../../store/Actions/CommonAction';
import dayjs from 'dayjs';

// eslint-disable-next-line react/prop-types
const MemberShipModel = ({ IsOpen = {}, Isclose, record = {}, MemberVerification = false }) => {
  const dispatch = useDispatch();
  const { memberShipData, roomTypeOptions } = useSelector(state => state?.MasterData);
  const { occupancyOptions } = useSelector(state => state?.OccupancyManagement);
  const { programmeData } = useSelector(state => state?.Service);
  const [isLoading, setIsLoading] = useState(false);
  const hasFetchedData = useRef(false);

  useEffect(() => {
    // Only fetch data when modal is open and hasn't been fetched yet
    if (IsOpen?.is && !hasFetchedData.current) {
      const needsToFetchData =
        !memberShipData?.[0]?.length ||
        !programmeData?.[0]?.docs?.length ||
        !roomTypeOptions?.length ||
        !occupancyOptions?.length;

      if (needsToFetchData) {
        setIsLoading(true);
        hasFetchedData.current = true;

        const promises = [];

        if (!memberShipData?.[0]?.length) {
          promises.push(dispatch(getAllMemberShip()));
        }
        if (!programmeData?.[0]?.docs?.length) {
          promises.push(dispatch(GetAllProgrammeList()));
        }
        if (!roomTypeOptions?.length) {
          promises.push(dispatch(ActionGetRoomTypeOptions({ Query: '?action=get_options' })));
        }
        if (!occupancyOptions?.length) {
          promises.push(dispatch(ActionGetOccupancyModeOptions({ Query: '?action=get_options' })));
        }

        // Wait for all promises to complete
        Promise.all(promises)
          .catch(error => {
            console.error('Error fetching membership data:', error);
            hasFetchedData.current = false; // Reset on error to allow retry
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }

    // Reset fetch flag when modal closes
    if (!IsOpen?.is) {
      hasFetchedData.current = false;
    }
  }, [IsOpen?.is, dispatch]);
  const membershipTypes =
    memberShipData?.[0]?.map(item => ({
      memberShipType: item?.memberShipType,
      memberShipId: item?._id,
    })) || [];
  const programmeInfo = programmeData?.[0]?.docs;
  const programmeName = programmeInfo?.map(option => option?.name?.en);
  const memberShipInfo = record?.memberShipDetails;
  const remark = record?.latestRemark || '';
  return (
    <>
      <div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            memberShipType: memberShipInfo?.[0]?.memberShipType || '',
            memberShipId: memberShipInfo?.[0]?.memberShipId || '',
            totalMemberShipDays: record?.totalMemberShipDays || '',
            // change key as per BE key for Life-time membership
            memberShipDays: memberShipInfo?.[0]?.memberShipDays || '',
            startDate:
              (memberShipInfo?.[0]?.startDate && dayjs(memberShipInfo?.[0]?.startDate)) ||
              null,
            endDate:
              (memberShipInfo?.[0]?.endDate && dayjs(memberShipInfo?.[0]?.endDate)) || null,
            programme: memberShipInfo?.[0]?.programme || '',
            programmeId: memberShipInfo?.[0]?.programmeId || '',
            roomType: memberShipInfo?.[0]?.roomType || '',
            type: memberShipInfo?.[0]?.type || '',
            price: memberShipInfo?.[0]?.price || '',
            roomTypeId: (typeof memberShipInfo?.[0]?.roomTypeId === 'object' ? memberShipInfo?.[0]?.roomTypeId?._id : memberShipInfo?.[0]?.roomTypeId) || '',
            occupancyModeId: (typeof memberShipInfo?.[0]?.occupancyModeId === 'object' ? memberShipInfo?.[0]?.occupancyModeId?._id : memberShipInfo?.[0]?.occupancyModeId) || '',
            remark: memberShipInfo?.[0]?.remark || remark,
            financialYear: memberShipInfo?.[0]?.financialYear?.map(item => ({
              year: Object.keys(item)[0],
              days: item[Object.keys(item)[0]],
            })) || [{ year: '', days: '' }],
          }}
          validationSchema={AddMemberShipValidationSchema}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            let formattedValues = {
              ...values,
              // isMemberShipVerified: true,
              isMemberShipVerified: MemberVerification ? true : false,
              startDate: values?.startDate ? values?.startDate : null,
              endDate: values?.endDate ? values?.endDate : null,
              financialYear: values?.financialYear?.map(item => ({
                [item?.year]: item?.days,
              })),
            };

            // no need this every time we update membership and also not required for verify membership
            // if (record?._id) {
            //   formattedValues = {
            //     ...formattedValues,
            //     isMemberShipVerified: true,
            //   };
            // }
            let query;
            if (record?._id) {
              query = `admin/customers/update_membership/${record?._id}`;
            } else {
              query = `admin/customers/update_membership/${IsOpen.id}`;
            }

            dispatch(
              ActionUpdateById({ Query: query, obj: formattedValues }, Res => {
                if (Res?.statusCode === 200) {
                  if (record?._id) {
                    dispatch(getAllMemberShipVerifyList());
                    window.location.href = `/verify-member?page=1`;
                  } else {
                    Isclose();
                  }
                } else if (Res?.statusCode === 400) {
                  setErrors(Res?.data?.errors);
                }
                setSubmitting(false);
              })
            );
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
          }) => {
            const isLifeMembership =
              values?.memberShipType === 'Life Membership' ||
              values?.memberShipType === 'LifeTime' ||
              values?.memberShipType === 'Life Time';
            return (
              <div>
                <Modal
                  open={IsOpen?.is}
                  closable={true}
                  forceRender={true}
                  zIndex={1040}
                  width={1000}
                  onOk={() => handleSubmit()}
                  styles={{
                    body: {
                      overflowX: 'hidden',
                      overflowY: 'auto',
                      maxHeight: 'calc(100vh - 200px)',
                    },
                    mask: {
                      backdropFilter: 'blur(10px)',
                    },
                    content: {
                      borderRadius: 40,
                      width: 1000,
                      maxWidth: '95vw',
                    },
                  }}
                  okText={'Submit'}
                  centered
                  onCancel={Isclose}
                  closeIcon={true}
                >
                  <Spin spinning={isLoading} tip="Loading membership data...">
                    <div className="px-4">
                      <div className="invoice-add-table">
                        <h4>{record?.isMemberShip ? 'Edit MemberShip' : 'Add MemberShip'}</h4>
                        <div className="form-group">
                          <div className="row">
                            <InputFromUser
                              label="Membership Type"
                              type="singleSelect"
                              name="memberShipType"
                              onChange={value => {
                                handleChange({
                                  target: {
                                    name: 'memberShipType',
                                    value,
                                  },
                                });
                                const selectedMemberShip = memberShipData?.[0]?.find(
                                  type => type?.memberShipType === value
                                );
                                const selectedMemberShipId = selectedMemberShip?._id;
                                setFieldValue('memberShipId', selectedMemberShipId, true);
                              }}
                              onBlur={() => {
                                handleBlur({
                                  target: {
                                    name: 'memberShipType',
                                    value: true,
                                  },
                                });
                              }}
                              FormControlClassName={'form-control'}
                              FormGroupClassName={'col-xl-6 col-md-12 '}
                              LabelClassName={'col-form-label'}
                              value={values?.memberShipType}
                              disabled={MemberVerification}
                              error={errors?.memberShipType}
                              options={
                                membershipTypes?.map(type => type?.memberShipType) || []
                              }
                              touched={touched?.memberShipType}
                              placeholder={'Membership Type'}
                            />
                            <InputFromUser
                              label="Total Membership Days Remaining"
                              type="number"
                              name="totalMemberShipDays"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              FormControlClassName={'form-control'}
                              FormGroupClassName={'col-xl-6 col-md-12 '}
                              LabelClassName={'col-form-label'}
                              disabled={MemberVerification}
                              value={values?.totalMemberShipDays}
                              error={errors?.totalMemberShipDays}
                              touched={touched?.totalMemberShipDays}
                              placeholder={'Enter No Of Days'}
                            />
                            <InputFromUser
                              label="Remark"
                              type="text"
                              name="remark"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              FormControlClassName={'form-control'}
                              FormGroupClassName={isLifeMembership ? 'col-xl-6 col-md-12 ' : 'col-xl-12 col-md-12 '}
                              LabelClassName={'col-form-label'}
                              disabled={MemberVerification}
                              value={values?.remark}
                              error={errors?.remark}
                              touched={touched?.remark}
                              placeholder={'Enter Remark'}
                            />
                            {isLifeMembership && !MemberVerification && (
                              <InputFromUser
                                label="  Membership Days(Only for LM)"
                                type="text"
                                name="memberShipDays"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                FormControlClassName={'form-control'}
                                FormGroupClassName={'col-xl-6 col-md-12 '}
                                LabelClassName={'col-form-label'}
                                disabled={MemberVerification}
                                value={values?.memberShipDays}
                                error={errors?.memberShipDays}
                                touched={touched?.memberShipDays}
                                placeholder={'Enter No Of Days'}
                              />
                            )}
                          </div>
                          <div className="row">
                            <InputFromUser
                              label="Start"
                              type="date"
                              name="startDate"
                              onChange={v => {
                                setFieldValue('startDate', v, true);
                              }}
                              onBlur={handleBlur}
                              FormControlClassName={'form-control'}
                              FormGroupClassName={'col-xl-6 col-md-12 '}
                              LabelClassName={'col-form-label'}
                              value={values?.startDate}
                              disabled={MemberVerification}
                              error={errors?.startDate}
                              touched={touched?.startDate}
                              placeholder={'Select From Date '}
                            />
                            <InputFromUser
                              label="End"
                              type="date"
                              name="endDate"
                              onChange={v => {
                                setFieldValue('endDate', v, true);
                              }}
                              onBlur={handleBlur}
                              FormControlClassName={'form-control'}
                              FormGroupClassName={'col-xl-6 col-md-12 '}
                              LabelClassName={'col-form-label'}
                              value={values?.endDate}
                              disabled={MemberVerification}
                              error={errors?.endDate}
                              touched={touched?.endDate}
                              placeholder={'Select End Date '}
                            />
                          </div>
                          <div className="row">
                            <InputFromUser
                              label="Programme"
                              type="singleSelect"
                              name="programme"
                              onChange={value => {
                                handleChange({
                                  target: {
                                    name: 'programme',
                                    value,
                                  },
                                });
                                const selectedProgramme = programmeInfo?.find(
                                  programme => programme?.name?.en === value
                                );
                                const selectedProgrammeId = selectedProgramme?._id;
                                setFieldValue('programmeId', selectedProgrammeId, true);
                              }}
                              onBlur={() => {
                                handleBlur({
                                  target: {
                                    name: 'programme',
                                    value: true,
                                  },
                                });
                              }}
                              FormControlClassName={'form-control'}
                              FormGroupClassName={'col-xl-6 col-md-12 '}
                              LabelClassName={'col-form-label'}
                              value={values?.programme}
                              disabled={MemberVerification}
                              error={errors?.programme}
                              options={programmeName || []}
                              touched={touched?.programme}
                              placeholder={'Programme'}
                            />
                            <InputFromUser
                              label="Room Type"
                              type="singleSelect"
                              name="type"
                              onChange={value => {
                                handleChange({
                                  target: {
                                    name: 'type',
                                    value,
                                  },
                                });
                              }}
                              onBlur={() => {
                                handleBlur({
                                  target: {
                                    name: 'type',
                                    value: true,
                                  },
                                });
                              }}
                              FormControlClassName={'form-control'}
                              FormGroupClassName={'col-xl-6 col-md-12 '}
                              LabelClassName={'col-form-label'}
                              disabled={MemberVerification}
                              value={values?.type}
                              error={errors?.type}
                              options={['Shared', 'Private']}
                              touched={touched?.type}
                              placeholder={'Room Type'}
                            />
                            <InputFromUser
                              label="Room Category"
                              type="singleSelect"
                              name="roomType"
                              onChange={value => {
                                handleChange({
                                  target: {
                                    name: 'roomType',
                                    value,
                                  },
                                });
                                const selectedRoom = roomTypeOptions?.find(
                                  item => (item?.name || item?.label) === value
                                );
                                if (selectedRoom) {
                                  setFieldValue('roomTypeId', selectedRoom?._id || selectedRoom?.id || selectedRoom?.value, true);
                                }
                              }}
                              onBlur={() => {
                                handleBlur({
                                  target: {
                                    name: 'roomType',
                                    value: true,
                                  },
                                });
                              }}
                              FormControlClassName={'form-control'}
                              FormGroupClassName={'col-xl-6 col-md-12 '}
                              LabelClassName={'col-form-label'}
                              disabled={MemberVerification}
                              value={values?.roomType}
                              error={errors?.roomType}
                              // options={roomTypeOptions?.map(item => item?.name || item?.label) || [
                              options={[
                                'General Ward',
                                'Basic Room',
                                'Semi Deluxe',
                                'Deluxe Room',
                                'Executive Room',
                                'Royal Room',
                                'Deluxe',
                                'Executive',
                              ]}
                              touched={touched?.roomType}
                              placeholder={'Room Category'}
                            />
                            <InputFromUser
                              label="Room Category ID"
                              type="singleSelect"
                              name="roomTypeId"
                              onChange={value => {
                                handleChange({
                                  target: {
                                    name: 'roomTypeId',
                                    value,
                                  },
                                });
                                const selectedRoom = roomTypeOptions?.find(
                                  item => (item?._id || item?.id || item?.value) === value
                                );
                                if (selectedRoom) {
                                  setFieldValue('roomType', selectedRoom?.name || selectedRoom?.label, true);
                                }
                              }}
                              onBlur={() => {
                                handleBlur({
                                  target: {
                                    name: 'roomTypeId',
                                    value: true,
                                  },
                                });
                              }}
                              FormControlClassName={'form-control'}
                              FormGroupClassName={'col-xl-6 col-md-12 '}
                              LabelClassName={'col-form-label'}
                              disabled={MemberVerification}
                              value={values?.roomTypeId}
                              error={errors?.roomTypeId}
                              options={roomTypeOptions?.map(item => ({
                                label: item?.name || item?.label,
                                value: item?._id || item?.id || item?.value,
                              })) || []}
                              touched={touched?.roomTypeId}
                              placeholder={'Select Room Type'}
                            />
                            <InputFromUser
                              label="Occupancy Mode"
                              type="singleSelect"
                              name="occupancyModeId"
                              onChange={value => {
                                handleChange({
                                  target: {
                                    name: 'occupancyModeId',
                                    value,
                                  },
                                });
                              }}
                              onBlur={() => {
                                handleBlur({
                                  target: {
                                    name: 'occupancyModeId',
                                    value: true,
                                  },
                                });
                              }}
                              FormControlClassName={'form-control'}
                              FormGroupClassName={'col-xl-6 col-md-12 '}
                              LabelClassName={'col-form-label'}
                              disabled={MemberVerification}
                              value={values?.occupancyModeId}
                              error={errors?.occupancyModeId}
                              options={occupancyOptions?.map(item => ({
                                label: item?.name || item?.label,
                                value: item?._id || item?.id || item?.value,
                              })) || []}
                              touched={touched?.occupancyModeId}
                              placeholder={'Select Occupancy Mode'}
                            />
                            <InputFromUser
                              label="Price"
                              type="number"
                              name="price"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              FormControlClassName={'form-control'}
                              FormGroupClassName={'col-xl-6 col-md-12 '}
                              LabelClassName={'col-form-label'}
                              disabled={MemberVerification}
                              value={values?.price}
                              error={errors?.price}
                              touched={touched?.price}
                              placeholder={'Enter Price'}
                            />

                          </div>
                          {isLifeMembership ? (
                            <ExpendableTable
                              Title={'Financial Year'}
                              emptyDataForCreatingField={{ year: '', days: '' }}
                              Data={values?.financialYear || []}
                              placeholder={'Enter year (2023-24)'}
                              Columns={[
                                { name: 'year', type: 'text', label: 'Year(yyyy-yyyy)' },
                                { name: 'days', type: 'number', label: 'Days' },
                                { name: 'Action', type: 'action', label: 'Action' },
                              ]}
                              onChange={v => {
                                // Format the financialYear array
                                const formattedFinancialYear = v.map(item => ({
                                  year: String(item?.year),
                                  days: parseInt(item?.days, 10),
                                }));
                                setFieldValue(
                                  'financialYear',
                                  formattedFinancialYear,
                                  true
                                );
                              }}
                              onBlur={v => setFieldTouched('financialYear', v, true)}
                              disabled={MemberVerification}
                              // errors={errors?.wordsOfGratitude}
                              touched={touched?.financialYear}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </Spin>
                </Modal>
              </div>
            );
          }}
        </Formik>
      </div>
    </>
  );
};
MemberShipModel.propTypes = {
  IsOpen: PropTypes.object,
  Isclose: PropTypes.func,
  record: PropTypes.shape({
    isMemberShip: PropTypes.bool,
    memberShipType: PropTypes.string,
    memberShipId: PropTypes.string,
    totalMemberShipDays: PropTypes.number,
    memberShipDays: PropTypes.number,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    programme: PropTypes.string,
    programmeId: PropTypes.string,
    type: PropTypes.string,
    roomTypeId: PropTypes.string,
    occupancyModeId: PropTypes.string,
    roomType: PropTypes.string,
    price: PropTypes.string,
    financialYear: PropTypes.arrayOf(
      PropTypes.shape({
        year: PropTypes.string,
        days: PropTypes.number,
      })
    ),
  }),
};
export default MemberShipModel;
